if (!customElements.get('dendro-editorial')) {
  customElements.define('dendro-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      for (const table of this.querySelectorAll('[data-editorial-body] table')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'dendro-editorial__table';
        wrapper.tabIndex = 0;
        table.before(wrapper);
        wrapper.append(table);
      }
      const headings = [...this.querySelectorAll('.dendro-editorial__article h2')]
        .filter(heading => !heading.closest('.dendro-editorial-product'));
      if (headings.length < 2) return;
      const usedIds = new Set([...document.querySelectorAll('[id]')].map(element => element.id));
      const list = document.createElement('ol');
      for (const [index, heading] of headings.entries()) {
        if (!heading.id) {
          const base = `article-${heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || index + 1}`;
          let id = base;
          let suffix = 2;
          while (usedIds.has(id)) id = `${base}-${suffix++}`;
          heading.id = id;
          usedIds.add(id);
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      }
      for (const target of this.querySelectorAll('[data-editorial-toc]')) target.replaceChildren(list.cloneNode(true));
      for (const target of this.querySelectorAll('[data-editorial-mobile-toc], [data-editorial-sidebar]')) target.hidden = false;
    }
  });
}
